import {
	MOBILE_L_BP,
	TABLET_M_BP,
} from "@website-builder/utilities/constants/style-constants/screen-sizes.js";
import styled from "styled-components";

export const BoldTextWrapper = styled.div`
	${({ isTwoColumnSectionContent }) =>
		isTwoColumnSectionContent
			? `
        margin-right: 52px;
        padding-right: calc(8.33% + 24px);
    `
			: ""}

	.mobile-text {
		display: none;
	}

	@media only screen and (max-width: ${TABLET_M_BP}px) {
		${({ isTwoColumnSectionContent }) =>
			isTwoColumnSectionContent
				? `
            padding-right: 0;
    `
				: ""}
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		margin: 0;

		.mobile-text {
			display: block;
		}
		.desktop-text {
			display: none;
		}
	}
`;

export const TextItem = styled.div`
	& > div {
		text-align: center;
		font-size: ${(props) => props?.fs || "1rem"};
	}
`;
